<div class="result-card {{border}} {{ customs }}">
  <div class="result-card-header bg-bg-2 p-2">
    <ng-content *ngTemplateOutlet="headerTemplate"></ng-content>
  </div>
  <div class="result-card-body p-2">
    <ng-content *ngTemplateOutlet="bodyTemplate"></ng-content>
  </div>
</div>
